<template>
  <nav id="navbar">
    <ul class="navigation">
      <li class="navigation-item">
        <router-link :to="{ path: '/aviation' }" class="navigation-link">Aviation</router-link>
      </li>
      <li class="navigation-item">
        <router-link :to="{ path: '/maritime' }" class="navigation-link">Maritime</router-link>
      </li>
      <li class="navigation-item" v-if="$store.getters.isAdmin">
        <router-link :to="{ path: '/admin' }" class="navigation-link">Admin</router-link>
      </li>
    </ul>

    <ul class="user-profile-tab ml-auto">
      <b-dropdown variant="none" class="navigation-link" toggle-class="d-flex align-items-center text-white" right>
        <template v-slot:button-content>
          <img :src="require('../assets/img/user-icon.svg')" alt="User icon" class="user-icon mr-1" />
          <div>{{ $store.state.user.username || $store.state.user.email }}</div>
        </template>
        <b-dropdown-item @click.once="logoutUser()">
          <b-spinner small v-if="isLoggingOut"></b-spinner>
          <span :class="{ 'ml-2': isLoggingOut }">Logout</span>
        </b-dropdown-item>
        <b-dropdown-item @click="onClickChangePassword">
          Change Password
        </b-dropdown-item>
      </b-dropdown>
    </ul>

    <AdminUserEditModal modalId="profile-user-edit-modal" :user="$store.state.user" fieldToEdit="password" @editedUser="onChangedPassword" :isCurrentUser="true" />
  </nav>
</template>

<script>
import AdminUserEditModal from './Admin/AdminUserEditModal.vue';
export default {
  components: { AdminUserEditModal },
  data() {
    return {
      isLoggingOut: false
    };
  },

  methods: {
    logoutUser() {
      this.isLoggingOut = true;
      this.$store
        .dispatch('logout')
        .then(() => {
          this.isLoggingOut = false;
        })
        .catch(() => {
          console.log('Unexpected error occurred when trying to logout. Committing forced logout.');
          this.$store.commit('discardSession');
          this.isLoggingOut = false;
        })
        .finally(() => {
          this.$router.push('/login');
        });
    },

    onClickChangePassword() {
      this.fieldToEdit = 'password';
      this.$bvModal.show('profile-user-edit-modal');
    },

    onChangedPassword({ user }) {
      this.$bvToast.toast(`Successfully changed password for ${user.username}.`, {
        title: `User password changed`,
        variant: 'info',
        solid: true,
        autoHideDelay: 3000
      });
    }
  }
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

#navbar {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  height: 50px;
  width: 100%;
  align-items: flex-start;
  padding: 0;
  background-color: var(--color-dark);
  z-index: 10;
  // box-shadow: 0px 2px 3px 0px black;
}

.navigation {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 0.5rem;
}

.navigation-link {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 0.25rem 0.5rem;
  margin: 0 0.15rem;
  text-decoration: none;
  color: white;
  font-size: 1.25em;
}

.router-link-active {
  font-weight: 700;
  color: var(--primary);
}

.user-icon {
  width: 35px;
  height: 35px;
}
</style>
